import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';

const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

export const parseTradeline = (tradeline, bureau = ALL) => {
  const dueAmount = tradeline?.annotation?.creditUsage?.balance;
  const duePercent = tradeline?.annotation?.creditUsage?.utilizationPercentage;

  const suggestedReductionValue = dueAmount - tradeline?.creditLimit * 0.3;

  const getBgNotification = () => {
    if (duePercent >= 100) {
      return 'system_error_e025';
    } else if (duePercent >= 30 && duePercent < 100) {
      return 'system_ltblue_lb025';
    }
  };

  const getNotificationMessage = () => {
    if (duePercent >= 100) {
      return (
        <span>
          You have used the card over the provided credit limit. We recommend
          you{' '}
          <span className="bold">
            reduce this card's usage by ${suggestedReductionValue} or more.
          </span>{' '}
          Lenders like to see credit usage of 30% or lower.
        </span>
      );
    } else if (duePercent >= 30) {
      return (
        <span>
          We recommend you{' '}
          <span className="bold">
            reduce this card's usage by ${suggestedReductionValue} or more.
          </span>{' '}
          Lenders like to see credit usage of 30% or lower.
        </span>
      );
    }
  };

  const parsedTradeline = {
    creditor: tradeline?.creditor,
    creditLimit: tradeline?.creditLimit,
    dueAmount: dueAmount,
    duePercent: duePercent,
    bureauBalance: {
      transunion: {
        balance:
          bureau === TRANS_UNION
            ? dueAmount
            : tradeline?.bureauBalance?.transUnion,
      },
      equifax: {
        balance:
          bureau === EQUIFAX ? dueAmount : tradeline?.bureauBalance?.equifax,
      },
      experian: {
        balance:
          bureau === EXPERIAN ? dueAmount : tradeline?.bureauBalance?.experian,
      },
    },
    bgNotification: getBgNotification(),
    notificationMessage: getNotificationMessage(),
    dontShowMessage: duePercent < 30,
    suggestedReductionValue: suggestedReductionValue,
  };

  return parsedTradeline;
};
